module.exports = __webpack_public_path__ + "static/media/folder-open-line.b2dfb5f3.svg";